import styled from 'styled-components';

const StyledThankYouContent = styled.div`
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .thank-you-result {
    position: relative;
    background-color: #fff;
    width: 80%;
    max-width: 1023px;
  }
  .thankyou-check{
    border-radius: 50%;
    background-color: ${props => props.theme.colors.green_secondary};
    width: 48px;
    height: 48px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .thankyou-check img{
    width: 24px;
  }
  .thank-you-result h6{
    margin-bottom: 40px;
  }
  .thank-you-result p{
    color: #4D4D4D;
    
  }
  .cta--primary {
    margin-top: 80px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    .cta--primary {
      margin-top: 40px;
    }
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    .thank-you-result {
      width: auto;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }
`;

export {
  StyledThankYouContent,
};

